exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "footer[data-v-5a4233f4]{position:static!important;max-height:64px}.container[data-v-5a4233f4]{width:100%!important;max-width:none!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-5a4233f4","scoped":true,"sourceMap":false}!./~/postcss-loader/lib!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/footer/IdoniaEmbedFooter.vue
// module id = 1039
// module chunks = 22